import { render, staticRenderFns } from "./StaffIndex.vue?vue&type=template&id=2ca0a384&scoped=true&"
import script from "./StaffIndex.vue?vue&type=script&lang=js&"
export * from "./StaffIndex.vue?vue&type=script&lang=js&"
import style0 from "./StaffIndex.vue?vue&type=style&index=0&id=2ca0a384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0a384",
  null
  
)

export default component.exports